import { Container } from "reactstrap";
import DeviceDetails from "./components/details";
import { ToastContainer, BackLink } from "../../components/Common";

const DeviceDetailsPage = () => (
    <div className="page-content">
        <Container fluid>
            <BackLink />
            <DeviceDetails />
        </Container>
        <ToastContainer />
    </div>
);

export default DeviceDetailsPage;
